import * as yup from 'yup'

import {
  CONSULTATION_FORMAT_OPTIONS,
  FORM_TYPES,
  TROUBLE_OPTIONS,
} from './contact.types'

export const contactSchema = yup.object({
  formType: yup
    .mixed<'consultation' | 'music-support'>()
    .oneOf([ FORM_TYPES.consultation, FORM_TYPES.musicSupport ])
    .required(),
  email: yup
    .string()
    .email('有効なメールアドレスを入力してください')
    .required('メールアドレスを入力してください'),
  firstName: yup.string().optional(),
  subject: yup.string().when('formType', {
    is: FORM_TYPES.musicSupport,
    then: (schema) => schema.optional(),
    otherwise: (schema) => schema.required('件名を入力してください').min(1, '件名を入力してください'),
  }),
  description: yup
    .string()
    .required('お困りごとを入力してください')
    .min(1, 'お困りごとを入力してください'),
  troubleType: yup.string().when('formType', {
    is: FORM_TYPES.musicSupport,
    then: (schema) =>
      schema
        .oneOf([ ...TROUBLE_OPTIONS ], 'お困りごとの種類を選択してください')
        .required('どれかひとつ選択してください'),
    otherwise: (schema) => schema.optional(),
  }),
  consultationFormat: yup.string().when('formType', {
    is: FORM_TYPES.musicSupport,
    then: (schema) =>
      schema
        .oneOf([ ...CONSULTATION_FORMAT_OPTIONS ], '相談形式を選択してください')
        .required('どれかひとつ選択してください'),
    otherwise: (schema) => schema.optional(),
  }),
})

export type TContactSchema = yup.InferType<typeof contactSchema>
